import { render, staticRenderFns } from "./HomeRegions.vue?vue&type=template&id=69054d8e&"
import script from "./HomeRegions.vue?vue&type=script&lang=js&"
export * from "./HomeRegions.vue?vue&type=script&lang=js&"
import style0 from "./HomeRegions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports